import { createSelector } from '@reduxjs/toolkit';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { RootState } from '../index';
import { getActiveStation } from './getActiveStation';
import { getProjectLayoutModel } from './getProjectLayoutModel';
import { getActiveJobLayoutModel } from './jobContextSelectors';

export const getContextCollectionName = createSelector(
  (state: RootState) => state.application.openContext,
  getProjectLayoutModel,
  getActiveJobLayoutModel,
  (state: RootState) => state.sharedComponentSet.sharedComponentSet,
  getActiveStation,
  (state: RootState) => state.productionModels,

  (
    openContext,
    projectLayoutModel,
    jobLayoutModel,
    sharedComponentSet,
    activeStation,
    productionModels,
  ): string | null => {
    if (!openContext) return null;

    const openContextType = openContext.type;
    switch (openContextType) {
      case 'project':
        return projectLayoutModel?.name ?? null;

      case 'job':
        return jobLayoutModel?.name ?? null;

      case 'shared-component-set':
        return sharedComponentSet?.name ?? null;

      case 'station':
        return activeStation?.name ?? null;

      case 'schedule-station': {
        return productionModels.activeScheduleLineGroupGuid
          ? ((
              productionModels.orderedScheduleLineGroups.find(
                (scheduleLineGroup) => scheduleLineGroup.guid === productionModels.activeScheduleLineGroupGuid,
              ) ?? null
            )?.name ?? null)
          : null;
      }

      default:
        assertExhaustiveSwitch(openContextType);
    }
  },
);
